// Module
var code = "<div class=\"card m-0 p-0 no-box-shadow\" ng-cloak> <div class=\"title\"> <h4>{{ctrl.model.headerText}}</h4> </div> <div class=\"content\"> <div class=\"row mt-0\"> <h5>{{ctrl.model.message}}</h5> </div> <div class=\"row mt-30\"> <button class=\"btn small green text-white\" ng-click=\"ctrl.close()\"> Ok </button> </div> </div> </div> ";
// Exports
export default code;